<kt-portlet class="knostos-grid">
  <kt-portlet-header [class]="'card-head-lg'">
    <ng-container ktPortletTitle>
      <div *ngIf="!isInbound">{{ 'CONTACT.CONTACTS_LIST' | translate }}</div>
      <div *ngIf="isInbound" class="card-title">
        <span class="card-icon">
          <span
            inlineSVG="assets/media/svg/icons/Communication/Incoming-call.svg"
            class="svg-icon svg-icon-xl svg-icon-primary"
          ></span>
        </span>
        <h3 class="card-label">Contacts found with telephone: {{ phone }}</h3>
      </div>
    </ng-container>
    <ng-container *ngIf="!isInbound" ktPortletTools>
      <div>
        <button *ngIf="filteredView" mat-raised-button class="btn btn-primary" (click)="addRel()">
          <span
            inlineSVG="assets/media/svg/icons/General/add_circle_icon.svg"
            class="svg-icon svg-icon-md"
          ></span>
          <span>{{ 'CONTACT.ADD_RELATIONSHIP' | translate }}</span>
        </button>
        <ng-template ngxPermissionsOnly="canAddContact">
          <button mat-raised-button class="btn btn-primary ml-2" (click)="createContact()">
            <span
              inlineSVG="assets/media/svg/icons/General/add_circle_icon.svg"
              class="svg-icon svg-icon-md"
            ></span>
            <span>{{ 'CONTACT.ADD_CONTACT' | translate }}</span>
          </button>
        </ng-template>
        <button
          mat-raised-button
          matTooltip="Export as CSV"
          class="btn btn-icon btn-primary ml-2"
          (click)="exportContactsAsCSV($event)"
        >
          <i class="fas fa-download"></i>
        </button>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="search-tool">
        <button
          *ngIf="!isInbound"
          style="width: 140px !important"
          class="btn btn-sm btn-light-{{ getItemCssClassByStatus(searchIsActiveSelect) }} mr-4"
          (click)="toggleStatus($event)"
        >
          {{ getItemStatusString(searchIsActiveSelect) }} Contacts
        </button>
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            (click)="resetSearchInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            {{ 'TABLE.SEARCH' | translate }}
            <strong>{{ 'TABLE.IN_ALL_FIELDS' | translate }}</strong>
          </mat-hint>
        </mat-form-field>
        <button
          *ngIf="!isInbound"
          matTooltip="Search by Field/s"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table
        #sort="matSort"
        matSort
        multiTemplateDataRows
        [dataSource]="dataSource"
        class="mat-elevation-z8"
      >
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'CONTACT.TABLE.ID' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let contact" class="gl-block">
            <span
              [matTooltip]="canViewContact() ? 'View Contact' : null"
              [class.clickable]="canViewContact()"
              (click)="viewContactDblclick(contact.id, contact)"
              >{{ contact.id }}</span
            >
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchId">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'CONTACT.TABLE.ID' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchIdInput"
                [placeholder]="'CONTACT.TABLE.ID' | translate"
              />
              <button *ngIf="searchIdInput" matSuffix mat-icon-button (click)="searchIdInput = ''">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="profile">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell
            *matCellDef="let contact"
            class="profile-pic gl-block justify-content-center clickable"
            (click)="showContactPhoto(contact)"
          >
            <kt-user-photo
              [create]="'false'"
              [size]="30"
              [type]="'object'"
              [editable]="false"
              [user$]="{ profileUrl: contact.pre_signed_url?.url }"
              [entityTypeAndGender]="{ type: 'CONTACT', gender: contact.gender }"
            ></kt-user-photo>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchProfile">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'CONTACT.TABLE.CONTACT' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let contact" class="gl-block flex-column align-items-start">
            <span
              [matTooltip]="canViewContact() ? 'View Contact' : null"
              [class.clickable]="canViewContact()"
              (click)="viewContactDblclick(contact.id + contact.first_name, contact)"
            >
              {{ contact.first_name }} {{ contact.middle_name }} {{ contact.last_name }}
              {{ contact.last_name2 }}
            </span>
            <a href="mailto:{{ contact.email }}">{{ contact.email }}</a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchNameEmail">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'CONTACT.TABLE.NAME_EMAIL' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchNameEmailInput"
                [placeholder]="'CONTACT.TABLE.NAME_EMAIL' | translate"
              />
              <button
                *ngIf="searchNameEmailInput"
                matSuffix
                mat-icon-button
                (click)="searchNameEmailInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="username">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'CONTACT.TABLE.USER_NAME' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let contact" class="gl-block flex-column align-items-start">
            <span
              [matTooltip]="canViewContact() ? 'View Contact' : null"
              [class.clickable]="canViewContact()"
              (dblclick)="viewContact(contact.id)"
            >
              {{ contact.username }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchUsername">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'CONTACT.TABLE.USER_NAME' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchUsernameInput"
                [placeholder]="'CONTACT.TABLE.USER_NAME' | translate"
              />
              <button
                *ngIf="searchUsernameInput"
                matSuffix
                mat-icon-button
                (click)="searchUsernameInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="cellPhone">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'CONTACT.TABLE.CELL_PHONE' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let contact" class="gl-block">{{
            contact.cell_phone | phoneFormat
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchCellPhone">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'CONTACT.TABLE.CELL_PHONE' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchCellPhoneInput"
                [mask]="'(000) 000-0000'"
                [placeholder]="'CONTACT.TABLE.CELL_PHONE' | translate"
              />
              <button
                *ngIf="searchCellPhoneInput"
                matSuffix
                mat-icon-button
                (click)="searchCellPhoneInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="entityType">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'CONTACT.TABLE.TYPES' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let contact">
            <span [tooltip]="contact.entity_type | titlecase">
              <span
                class="label label-dot label-{{ contact.entity_type | getEntityStyle }} mr-2"
              ></span>
              <span class="font-weight-bold text-{{ contact.entity_type | getEntityStyle }}">{{
                contact.entity_types
              }}</span>
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchEntityType">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'CONTACT.TABLE.TYPES' | translate }}</mat-label>
              <mat-select [(value)]="searchEntityTypeSelect" multiple>
                <mat-option *ngFor="let type of entity_types" [value]="type.value">{{
                  type.name
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="isActive">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'CONTACT.TABLE.STATUS' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let contact">
            <span
              style="width: 61px"
              class="label label-lg label-light-{{
                getItemCssClassByStatus(contact.is_active?.toString())
              }} label-inline text-center"
            >
              {{ getItemStatusString(contact.is_active?.toString()) }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchIsActive">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'CONTACT.TABLE.STATUS' | translate }}</mat-label>
              <mat-select
                [(value)]="searchIsActiveSelect"
                [placeholder]="'CONTACT.TABLE.STATUS' | translate"
                (selectionChange)="handleStatusChange()"
              >
                <mat-option value="">All</mat-option>
                <mat-option value="true">Active</mat-option>
                <mat-option value="false">Inactive</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let contact">
            <ng-template *ngIf="!filteredView" ngxPermissionsOnly="canAccessFilteredView">
              <button
                matTooltip="Focused View"
                class="btn btn-icon btn-light btn-hover-success btn-sm m-1"
                (click)="$event.stopPropagation(); openFilteredViewDialog(contact)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/focus-svgrepo-com.svg"
                  class="svg-icon svg-icon-md svg-icon-success"
                ></span>
              </button>
            </ng-template>
            <ng-template *ngIf="!isInbound" ngxPermissionsOnly="canEditContact">
              <button
                matTooltip="{{ 'TABLE.UPDATE' | translate }} Contact"
                class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                (click)="editContact(contact.id)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-primary"
                ></span>
              </button>
            </ng-template>
            <ng-template *ngIf="!isInbound" ngxPermissionsOnly="canActivateContact">
              <button
                matTooltip="{{ 'TABLE.ACTIVATE_DEACTIVATE' | translate }} Contact"
                class="btn btn-icon btn-light btn-hover-warning btn-sm m-1"
                (click)="updateStatusForContact(contact)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/update_icon2.svg"
                  class="svg-icon svg-icon-md svg-icon-warning"
                ></span>
              </button>
            </ng-template>
            <ng-template *ngIf="!isInbound" ngxPermissionsOnly="canSoftDeleteContact">
              <button
                matTooltip="{{ 'TABLE.DELETE' | translate }} Contact"
                class="btn btn-icon btn-light btn-hover-danger btn-sm m-1"
                (click)="deleteContact(contact)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-danger"
                ></span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button class="btn btn-sm btn-light w-50 m-1" (click)="resetSearchBar($event)">
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
          <div mat-cell *matCellDef="let element" class="w-100">
            <div
              class="element-detail"
              style="border-bottom-style: unset !important"
              [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
            >
              <table class="table table-head-bg table-borderless table-vertical-center">
                <thead>
                  <tr class="text-left text-uppercase">
                    <th style="min-width: 250px" class="pl-7 text-dark-75">
                      <ng-container
                        [ngTemplateOutlet]="columnHeader"
                        [ngTemplateOutletContext]="{
                          column: { label: 'Name', prop: 'name', elementID: element.id }
                        }"
                      ></ng-container>
                    </th>
                    <th style="min-width: 100px" class="text-dark-75">
                      <ng-container
                        [ngTemplateOutlet]="columnHeader"
                        [ngTemplateOutletContext]="{
                          column: {
                            label: 'Type',
                            prop: 'relationType.category.entityType',
                            elementID: element.id
                          }
                        }"
                      ></ng-container>
                    </th>
                    <th style="min-width: 100px" class="text-dark-75">
                      <ng-container
                        [ngTemplateOutlet]="columnHeader"
                        [ngTemplateOutletContext]="{
                          column: {
                            label: 'Category',
                            prop: 'relationType.category.name',
                            elementID: element.id
                          }
                        }"
                      ></ng-container>
                    </th>
                    <th style="min-width: 100px" class="text-dark-75">
                      <ng-container
                        [ngTemplateOutlet]="columnHeader"
                        [ngTemplateOutletContext]="{
                          column: {
                            label: 'Description',
                            prop: 'relationType.descriptionType',
                            elementID: element.id
                          }
                        }"
                      ></ng-container>
                    </th>
                    <th style="min-width: 100px" class="text-dark-75">Classification</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let x of list">
                    <td class="pl-7">
                      <span class="d-block font-size-lg gl-block">
                        <span>{{ x | getEntityName }}</span>
                        <i
                          *ngIf="x.is_prime"
                          class="flaticon2-correct text-success icon-md ml-2"
                        ></i>
                      </span>
                    </td>
                    <td>
                      <span class="font-size-lg">{{ x.entity_type }}</span>
                    </td>
                    <td>
                      <span class="font-size-lg">{{ x.relation_type }}</span>
                    </td>
                    <td>
                      <span class="font-size-lg"> {{ x.relationship_description }} </span>
                    </td>
                    <td>
                      <span
                        class="svg-icon svg-icon-md svg-icon-success cursor-pointer"
                        style="display: flex; height: 30px"
                      >
                        <span
                          class="m-1"
                          style="display: flex; align-items: center"
                          *ngIf="x.financial_responsible"
                          matTooltip="Financial Responsible"
                          inlineSVG="./assets/media/svg/icons/General/dollar.svg"
                        ></span>
                        <span
                          class="m-1"
                          style="display: flex; align-items: center"
                          *ngIf="x.emergency_contact"
                          matTooltip="Emergency Contact"
                          inlineSVG="./assets/media/svg/icons/General/siren.svg"
                        ></span>
                        <span
                          class="m-1"
                          style="display: flex; align-items: center"
                          *ngIf="x.phi_authorized"
                          matTooltip="PHI Authorized"
                          inlineSVG="./assets/media/svg/icons/General/hipaa_seal.svg"
                        ></span>
                      </span>
                    </td>
                  </tr>
                  <tr *ngIf="!list.length && !loading">
                    <td colspan="4" class="mat-table__message w-100">
                      {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
                    </td>
                  </tr>
                  <tr *ngIf="loading">
                    <td colspan="4" class="mat-table__message w-100">
                      {{ 'GLOBAL.PLEASE_WAIT' | translate }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarColumns"
          class="search-cols sticky-header"
        ></mat-header-row>

        <mat-row
          mat-row
          *matRowDef="let element; columns: displayedColumns"
          class="element-row"
          [class.expanded-row]="expandedElement === element"
          (click)="
            expandedElement = expandedElement === element ? (list = []) : element;
            loadRelation(element.id, '', '')
          "
        ></mat-row>
        <mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="detail-row"
          style="min-height: unset !important"
        ></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource?.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="pageSize || 25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
<ng-template #columnHeader let-column="column">
  <div class="col-header" (click)="handleSort($event, column)" style="margin-left: 10px">
    <div class="row">
      <label
        [style.padding-left]="column.label === 'NAME' ? '60px' : '0'"
        style="margin-bottom: 0"
        >{{ column.label }}</label
      >
      <span *ngIf="column.prop" class="sort-arrows ml-2">
        <i *ngIf="column.label !== sortRelation.label" class="hover-arrow fas fa-arrow-up"></i>
        <i
          *ngIf="column.label === sortRelation.label && sortRelation.type === 'ASC'"
          class="fas fa-arrow-up text-black-50"
        ></i>
        <i
          *ngIf="column.label === sortRelation.label && sortRelation.type === 'DESC'"
          class="fas fa-arrow-down text-black-50"
        ></i>
      </span>
    </div>
  </div>
</ng-template>
